module.exports = __webpack_public_path__ + "static/media/9DESA11.867de83d.jpg";